// Inline spinner that inherits the surrounding text color. Defaults to a small
// 13px glyph; pass `size` for a larger standalone progress indicator.
export function Spinner({ size = 13 }: { size?: number }) {
  return (
    <svg className="orion-spinner" width={size} height={size} viewBox="0 0 14 14" aria-hidden style={{ flexShrink: 0 }}>
      <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.6" fill="none" opacity="0.25" />
      <path d="M7 2a5 5 0 0 1 5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
    </svg>
  );
}
